/* dupe-quiz-engine.js — picks the set's scents (opts.n, default 3; the theme passes the section's set_count) from the tagged pool. Pure, no DOM, so node can test it.
   Spec: brands/dupes-il/quiz-tree.md ("איך בוחרים את ה-3"). Tags come from product metafields custom.quiz_*
   (Hebrew choices Adam edits in admin); the maps below turn them into keys.
   pool item: {handle,title,img,url,season,time,char,strength,compliments,why,original,brand}
   answers: {who, know, when[], season, char[], strength, ref[] (a single handle also works), want}  ('any' / [] = לא יודע = no filter)
   ref = the originals he said he likes. Up to 3: each one's scent is in the set and the rest are filled in their
   style (same character scores up, and the "no two of one character" rule is off). More than 3: the set is the 3 of
   them that fit his other answers best. A picked scent carries fromRef, a fill in a picked scent's character carries near. */
(function (root) {
  var SEASON = { 'קיץ': 'summer', 'חורף': 'winter', 'כל השנה': 'all' };
  var TIME = { 'יום': 'day', 'ערב': 'evening', 'גם וגם': 'both' };
  var CHAR = { 'נקי ורענן': 'fresh', 'חם וגברי': 'warm', 'מתוק': 'sweet' };
  var STRENGTH = { 'עדין': 'soft', 'בינוני': 'mid', 'חזק': 'strong' };
  function norm(p) {
    return { handle: p.handle, title: p.title, img: p.img, url: p.url, why: p.why || '', original: p.original || '', brand: p.brand || '',
      season: SEASON[p.season] || p.season || 'all', time: TIME[p.time] || p.time || 'both', char: CHAR[p.char] || p.char || '',
      strength: STRENGTH[p.strength] || p.strength || 'mid', compliments: p.compliments === true || p.compliments === 'true', idx: p.idx || 0 };
  }
  function roles(when) {
    var w = when || []; var any = !w.length || w.indexOf('any') > -1;
    var day = w.indexOf('day') > -1, eve = w.indexOf('evening') > -1 || w.indexOf('special') > -1;
    if (any || (day && eve)) return ['day', 'evening', 'season'];
    if (day) return ['day', 'day', 'season'];
    return ['evening', 'evening', 'season'];
  }
  function roleOk(p, role, season) {
    if (role === 'day') return p.time === 'day' || p.time === 'both';
    if (role === 'evening') return p.time === 'evening' || p.time === 'both';
    if (season === 'summer') return p.season === 'summer';
    if (season === 'winter') return p.season === 'winter';
    return true; // season role with no season: anything
  }
  function seasonOk(p, season) { return season === 'summer' ? p.season !== 'winter' : season === 'winter' ? p.season !== 'summer' : true; }
  function score(p, a) {
    var s = p.compliments ? 1 : 0;
    var chars = (a.char || []).filter(function (c) { return c !== 'any'; });
    if (chars.length && chars.indexOf(p.char) > -1) s += 3;
    if (a.strength && a.strength !== 'any') { if (p.strength === a.strength) s += 2; else if (a.strength === 'strong' && p.strength === 'mid') s += 1; else if (a.strength === 'soft' && p.strength === 'mid') s += 1; }
    if (a.want === 'lasting') s += p.strength === 'strong' ? 2 : p.strength === 'mid' ? 1 : 0;
    if (a.want === 'light') s += (p.strength !== 'strong' ? 2 : 0) + (p.char === 'fresh' ? 1 : 0);
    if (a.want === 'react') s += p.compliments ? 2 : 0;
    if (a.want === 'fit') s += p.compliments ? 1 : 0;
    (a._liked || []).some(function (r) { if (r.char !== p.char) return false; s += 3 + (r.strength === p.strength ? 1 : 0); return true; });
    return s;
  }
  // relaxation ladder: each step drops one constraint, the result is never empty while the pool is not
  var LADDER = [
    { season: 1, strength: 1, char: 1, compl: 1, role: 1, dchar: 1, dbrand: 1 },
    { season: 1, strength: 0, char: 1, compl: 1, role: 1, dchar: 1, dbrand: 1 },
    { season: 1, strength: 0, char: 0, compl: 1, role: 1, dchar: 1, dbrand: 1 },
    { season: 1, strength: 0, char: 0, compl: 1, role: 1, dchar: 1, dbrand: 0 },
    { season: 1, strength: 0, char: 0, compl: 1, role: 0, dchar: 1, dbrand: 0 },
    { season: 1, strength: 0, char: 0, compl: 1, role: 0, dchar: 0, dbrand: 0 },
    { season: 0, strength: 0, char: 0, compl: 1, role: 0, dchar: 0, dbrand: 0 },
    { season: 0, strength: 0, char: 0, compl: 0, role: 0, dchar: 0, dbrand: 0 },
    { season: 0, strength: 0, char: 0, compl: 0, role: 0, dchar: 0, dbrand: 0, dup: 1 }
  ];
  function fill(role, pool, a, chosen, needCompl) {
    var chars = (a.char || []).filter(function (c) { return c !== 'any'; });
    chars = chars.filter(function (c) { return !chosen.some(function (ch) { return ch.char === c; }); });
    for (var L = 0; L < LADDER.length; L++) {
      var r = LADDER[L];
      var cand = pool.filter(function (p) {
        if (!r.dup && chosen.some(function (c) { return c.handle === p.handle; })) return false;
        if (r.role && !roleOk(p, role, a.season)) return false;
        if (r.season && !seasonOk(p, a.season)) return false;
        if (r.compl && needCompl && !p.compliments) return false;
        if (r.char && chars.length && chars.indexOf(p.char) === -1) return false;
        if (r.strength && a.strength && a.strength !== 'any' && p.strength !== a.strength) return false;
        if (r.dchar && !(a._liked || []).length && chosen.some(function (c) { return c.char === p.char; })) return false;
        if (r.dbrand && p.brand && chosen.some(function (c) { return c.brand === p.brand; })) return false;
        return true;
      });
      if (cand.length) { cand.sort(function (x, y) { return score(y, a) - score(x, a) || x.idx - y.idx; }); return cand[0]; }
    }
    return null;
  }
  function allUnknown(a) {
    var w = (a.when || []).filter(function (x) { return x !== 'any'; }), c = (a.char || []).filter(function (x) { return x !== 'any'; });
    return !w.length && !c.length && (!a.season || a.season === 'any') && (!a.strength || a.strength === 'any') && !refsOf(a).length;
  }
  function refsOf(a) { return [].concat(a.ref || []).filter(function (h) { return h && h !== 'none'; }); }
  function pick(rawPool, a, opts) {
    opts = opts || {}; a = Object.assign({}, a || {}); var N = opts.n || 3;
    var pool = rawPool.map(function (p, i) { var n = norm(p); n.idx = i; return n; });
    if (!pool.length) return [];
    var needCompl = a.who === 'gift' || a.know === 'none';
    var chosen = [];
    if (allUnknown(a)) {
      (opts.bestsellers || []).forEach(function (h) { var p = pool.filter(function (x) { return x.handle === h; })[0]; if (p && chosen.length < N) chosen.push(p); });
    }
    var rs = roles(a.when);
    var liked = chosen.length ? [] : refsOf(a).map(function (h) { return pool.filter(function (p) { return p.handle === h; })[0]; }).filter(Boolean);
    if (liked.length > N) {
      /* more liked scents than places: the three of them that fit the roles and the other answers best */
      rs.slice(0, N).forEach(function (role) { var m = fill(role, liked, a, chosen, false); if (m) chosen.push(Object.assign({}, m, { role: role, fromRef: true })); });
      rs = [];
    } else liked.forEach(function (ref) {
      var k = rs.findIndex(function (r) { return roleOk(ref, r, a.season); }); var rr = k > -1 ? rs.splice(k, 1)[0] : rs.pop(); chosen.push(Object.assign({}, ref, { role: rr, fromRef: true }));
    });
    a._liked = liked;
    function near(p) { var m = liked.filter(function (r) { return r.char === p.char && r.handle !== p.handle; })[0]; return m ? m.handle : ''; }
    for (var i = 0; i < rs.length && chosen.length < N; i++) {
      var p = fill(rs[i], pool, a, chosen, needCompl);
      if (p) chosen.push(Object.assign({}, p, { role: rs[i], near: near(p) }));
    }
    var guard = 0;
    while (chosen.length < N && guard++ < 5) { var q = fill('season', pool, a, chosen, false); if (!q) break; chosen.push(Object.assign({}, q, { role: 'season', near: near(q) })); }
    return chosen.slice(0, N);
  }
  /* one-scent mode (quiz opened from a product page, ?mode=one): the single best match for everything he said comes
     first, then two that complete it (other roles, other characters). bother = what annoys him in the scent he wears now. */
  function heroScore(p, a, needCompl) {
    var s = score(p, a);
    var w = (a.when || []).filter(function (x) { return x !== 'any'; });
    var day = w.indexOf('day') > -1, eve = w.indexOf('evening') > -1 || w.indexOf('special') > -1;
    if (day && eve) s += p.time === 'both' ? 2 : 1;
    else if (day) s += p.time === 'day' ? 2 : p.time === 'both' ? 1 : -3;
    else if (eve) s += p.time === 'evening' ? 2 : p.time === 'both' ? 1 : -3;
    if (a.season === 'summer' || a.season === 'winter') s += p.season === a.season ? 2 : p.season === 'all' ? 1 : -5;
    if (a.bother === 'fades') s += p.strength === 'strong' ? 2 : p.strength === 'mid' ? 1 : 0;
    if (a.bother === 'heavy') s += (p.strength !== 'strong' ? 2 : -2) + (p.char === 'fresh' ? 1 : 0);
    if (a.bother === 'unnoticed') s += (p.compliments ? 2 : 0) + (p.strength === 'strong' ? 1 : 0);
    if (needCompl && p.compliments) s += 2;
    return s;
  }
  function pickOne(rawPool, a, opts) {
    opts = opts || {}; a = Object.assign({}, a || {}); var N = opts.n || 3;
    var pool = rawPool.map(function (p, i) { var n = norm(p); n.idx = i; return n; });
    if (!pool.length) return [];
    var needCompl = a.who === 'gift' || a.know === 'none';
    var liked = refsOf(a).map(function (h) { return pool.filter(function (p) { return p.handle === h; })[0]; }).filter(Boolean);
    var hero = null, unsure = allUnknown(a) && (!a.bother || a.bother === 'none');
    if (unsure) (opts.bestsellers || []).some(function (h) { hero = pool.filter(function (x) { return x.handle === h; })[0] || null; return !!hero; });
    if (!hero) {
      var cand = (liked.length ? liked : pool).slice();
      var inSeason = cand.filter(function (p) { return seasonOk(p, a.season); }); if (inSeason.length) cand = inSeason;
      cand.sort(function (x, y) { return heroScore(y, a, needCompl) - heroScore(x, a, needCompl) || x.idx - y.idx; });
      hero = cand[0];
    }
    var rs = roles(a.when), k = rs.findIndex(function (r) { return roleOk(hero, r, a.season); });
    var heroRole = k > -1 ? rs.splice(k, 1)[0] : rs.shift();
    var chosen = [Object.assign({}, hero, { role: heroRole, hero: true, fromRef: liked.indexOf(hero) > -1, unsure: unsure })];
    a._liked = [];
    for (var i = 0; i < rs.length && chosen.length < N; i++) { var p = fill(rs[i], pool, a, chosen, needCompl); if (p) chosen.push(Object.assign({}, p, { role: rs[i] })); }
    var guard = 0;
    while (chosen.length < N && guard++ < 5) { var q = fill('season', pool, a, chosen, false); if (!q) break; chosen.push(Object.assign({}, q, { role: 'season' })); }
    return chosen.slice(0, N);
  }
  /* the three small bottles of the set: the next best matches for what he said, other than the large three, so the
     small ones let him try more directions that fit him */
  function pickSmall(rawPool, a, taken, n) {
    a = Object.assign({}, a || {}); a._liked = [];
    var needCompl = a.who === 'gift' || a.know === 'none';
    var pool = rawPool.map(function (p, i) { var x = norm(p); x.idx = i; return x; }).filter(function (p) { return (taken || []).indexOf(p.handle) === -1; });
    pool.sort(function (x, y) { return heroScore(y, a, needCompl) - heroScore(x, a, needCompl) || x.idx - y.idx; });
    return pool.slice(0, n || 3);
  }
  root.DupeQuizEngine = { pick: pick, pickOne: pickOne, pickSmall: pickSmall, roles: roles, norm: norm };
})(typeof module !== 'undefined' ? module.exports : window);
